import LGAPI from './_lg.js';
import httpClient from '@/apis/base/httpclient';

class VoucherAPI extends LGAPI {
  constructor() {
    super();
  }
  controllerName = 'Voucher';

  /**
   * Ghi sổ
   * NXCHIEN 26.06.2022
   */
  posted(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Sửa nhanh chứng từ
   * lhphong 29.05.2023
   */
  quickEditVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/quickEditVoucher',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Bỏ Ghi sổ
   * NXCHIEN 26.06.2022
   */
  unPosted(payload) {
    let request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Ghi sổ theo lô
   * NNLINH 08.07.2022
   */
  postBatch(payload) {
    let request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Bỏ ghi sổ theo lô
   * NNLINH 08.07.2022
   */
  unPostBatch(payload) {
    let request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Ghi sổ dành cho cam kết chi
   * HQMINH 19.07.2022
   */
  changeStatusPosted(payload) {
    let request = {
      url: this.getAPIUrl() + '/changeStatusPosted',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Ghi sổ hàng loạt dành cho cam kết chi
   * HQMINH 20.07.2022
   */
  changeStatusPostedBatchs(payload) {
    let request = {
      url: this.getAPIUrl() + '/changeStatusPostedBatchs',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Lấy số lượng tồn cho toàn bộ chứng từ xuất của các vật tư để validate khi cất
   * NVTUAN1 22.08.2022
   */
  getQuantityInventoryByType(param) {
    let request = {
      url: this.getAPIUrl() + '/quantityInventoryByType',
      data: param,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Lấy số lượng tồn cho công cụ dụng cụ để validate điều chuyển, ghi giảm khi cất
   * lttuan1 30.12.2022
   */
  getQuantityToolByDepartment(param) {
    let request = {
      url: this.getAPIUrl() + '/quantityToolByDepartment',
      data: param,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new VoucherAPI();
